import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "accordian" }
const _hoisted_2 = { class: "details" }
const _hoisted_3 = ["id", "aria-controls", "aria-expanded", "aria-label"]
const _hoisted_4 = ["id", "aria-labelledby", "aria-expanded", "aria-hidden"]

import { ref } from 'vue';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'Accordian',
  props: {
    isExpanded: { type: Boolean },
    panelId: {},
    controlId: {},
    headerLabel: {}
  },
  setup(__props: any) {

const props = __props;

const isPanelExpanded = ref(props.isExpanded);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header"),
      _createElementVNode("button", {
        id: _ctx.controlId,
        "aria-controls": _ctx.panelId,
        "aria-expanded": isPanelExpanded.value,
        "aria-label": `${isPanelExpanded.value ? _ctx.$t('Collapse accordion') : _ctx.$t('Expand accordion')}: ${_ctx.headerLabel}`,
        class: _normalizeClass(["arrow", {expanded: isPanelExpanded.value}]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isPanelExpanded.value = !isPanelExpanded.value))
      }, [
        _createVNode(_unref(Icon), { "icon-name": "redChevron" })
      ], 10, _hoisted_3)
    ]),
    _createElementVNode("div", {
      id: _ctx.panelId,
      "aria-labelledby": _ctx.controlId,
      "aria-expanded": isPanelExpanded.value,
      "aria-hidden": !isPanelExpanded.value,
      role: "region",
      class: _normalizeClass(["accordianContent", {panelActive: isPanelExpanded.value}])
    }, [
      _renderSlot(_ctx.$slots, "content")
    ], 10, _hoisted_4)
  ]))
}
}

})